/**
 * m3 echo Frontend - Onboarding Page
 *
 * Full-screen wrapper around OnboardingWizard. Routing/auth is handled
 * in App.tsx (see /onboarding route) - this page assumes the user is
 * already authenticated.
 */

import React from 'react';
import { Box } from '@mui/material';
import OnboardingWizard from '../components/OnboardingWizard';

const OnboardingPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        bgcolor: 'background.default',
      }}
    >
      <OnboardingWizard />
    </Box>
  );
};

export default OnboardingPage;
